import "./add-task-card";

import { Storybook } from "@tento-ui/ui/storybook";
import { NuxAddTaskCard } from "./add-task-card";
import { $makeHomeCard } from "@tento-ui/components/home-card/home-grid-card.example";
import { Tracing } from "@tento-core/tracing";

const exampleCallbacks: NuxAddTaskCard.Callbacks = {
  onOpenTasks: () => Tracing.dev("storybook", "Open tasks clicked"),
};

export class NuxAddTaskCardStoryBook extends Storybook.Default {
  title(): string {
    return "Nux Add Task Card";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "In Context",
        render: () =>
          $makeHomeCard({
            title: "Add a task",
            contentBg: "var(--bg-surface-light-opaque)",
            $cardContent: NuxAddTaskCard.makeWith(exampleCallbacks),
          }),
      },
      {
        title: "Raw",
        render: () => NuxAddTaskCard.makeWith(exampleCallbacks),
      },
    ];
  }
}
